import { useBoatDetails } from 'components/pdp/v3/hooks';
import RenterActions from './SidebarRenterActions';
import OwnerActions from './SidebarOwnerActions';
import CaptainActions from './SidebarCaptainActions';

const SidebarBookingActions = ({ booking, userType, conversationId, hideBookingActions }) => {
  const userTypeInConvo = userType === 'admin' ? 'renter' : userType;
  const components = {
    renter: RenterActions,
    owner: OwnerActions,
    captain: CaptainActions,
  };

  const { boatDetails } = useBoatDetails(booking?.boat?.id);

  const Actions = components[userTypeInConvo];

  if (userTypeInConvo === 'anonymous' || userTypeInConvo === 'other') {
    return <div />;
  }
  return (
    <Actions
      conversationId={conversationId}
      booking={booking}
      userType={userTypeInConvo}
      hideBookingActions={hideBookingActions}
      boat={boatDetails}
    />
  );
};

export default SidebarBookingActions;
